import { Box } from '@components/Box';
import { ButtonNoneStyled } from '@components/ButtonNoneStyled';
import { CTALink } from '@components/CTALink';
import { TextPairing } from '@components/TextPairing';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import Carousel from 'nuka-carousel';
import styled from 'styled-components';

export const StyledContainer = styled(Box)`
  border-radius: ${themeSpace(5)};
  background-color: white;
  padding: ${themeSpace(5)} ${themeSpace(5)} ${themeSpace(10)};
`;

export const StyledTextPairing = styled(TextPairing)`
  align-items: center;
  .text-pairing-title {
    font-weight: 700;
  }
`;

export const StyledCTALink = styled(CTALink)`
  color: ${(props) => props.theme.colors.mono1};
`;

export const SlideButton = styled(ButtonNoneStyled)`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  height: ${themeSpace(9)};
  width: ${themeSpace(9)};
  background-color: rgba(247, 247, 247, 0.8);
  box-shadow: 0px 7px 16px -8px rgba(0, 0, 0, 0.3), 0px 10px 27px -5px rgba(44, 41, 37, 0.25);

  &:hover svg {
    color: ${themeColor('neutra6')};
  }
`;

export const PreviousSlideButton = styled(SlideButton)`
  left: ${themeSpace(4)};
  ${themeMediaQuery('sm')} {
    left: ${themeSpace(3)};
  }
`;

export const NextSlideButton = styled(SlideButton)`
  right: ${themeSpace(4)};
  ${themeMediaQuery('sm')} {
    right: ${themeSpace(3)};
  }
`;

export const StyledCarousel = styled(Carousel)`
  .slider-slide:not(.slide-visible) {
    visibility: hidden;
  }
`;
